import { ExportsPresenter } from 'components/domain/exports/ExportsPresenter'
import { AppLayout } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { Redirect } from 'react-router-dom'

export const Exports = (): JSX.Element => {
  const { user } = useUser()

  if (!user || user?.subscription.allFeaturesDisabled || user?.featureFlags?.banned) {
    return <Redirect to="/" />
  }

  return (
    <AppLayout noDOMLayout>
      <ExportsPresenter />
    </AppLayout>
  )
}
